import { clsx } from 'clsx'
import * as React from 'react'

export const READMEStepper = ({
  steps,
}: {
  steps: Array<{
    disabled?: boolean
    title: React.ReactNode
    subtitle: React.ReactNode
    children: React.ReactNode
  }>
}) => {
  return (
    <div className="flex-1 overflow-hidden">
      {steps.map((step, index) => {
        return (
          <div className="pl-2 group" key={index}>
            <div
              className={clsx(
                "relative border-l pb-8 border-dark-border-solid pl-6 before:absolute before:top-1 before:-left-2 before:z-20 before:h-4 before:w-4 before:rounded-full before:border before:border-dark-border-solid before:bg-dark-base before:ring-8 before:ring-dark-base before:ring-opacity-100 before:content-['']",
                'group-last:pb-0 group-last:border-l-0',
                step.disabled && 'opacity-50 pointer-events-none select-none'
              )}
            >
              <div className="mb-4 space-y-1">
                <div className="font-medium">{step.title}</div>
                {step.subtitle && (
                  <div className="max-w-[600px] text-sm leading-[19px] text-dark-muted text-pretty">
                    {step.subtitle}
                  </div>
                )}
              </div>

              {step.children}
            </div>
          </div>
        )
      })}
    </div>
  )
}
